import {Alert, AlertTitle, Button, Dialog} from "@mui/material";

export function ShowError(props: {
    message: string;
    onDone(): void;
}) {

    return (
        <Dialog open>
            <Alert severity="error">
                <AlertTitle>Error</AlertTitle>
                <div>
                    {props.message}
                </div>

                <div style={{height: 8}} />
                <Button variant="outlined" onClick={props.onDone}>Dismiss</Button>
            </Alert>
        </Dialog>
    )
}